(function () {
  class RecommendationsTabs {
    constructor(root) {
      this.root = root;
      this.tabs = Array.from(root.querySelectorAll('.product-recommendations-tabs__tab'));
      this.panels = Array.from(root.querySelectorAll('.product-recommendations-tabs__panel'));
      this.state = new Map();

      this.panels.forEach((panel) => {
        const key = panel.dataset.tabsPanel;
        const widget = panel.querySelector('product-recommendations');
        this.state.set(key, widget && widget.dataset.url ? 'pending' : 'empty');
      });

      // Checked independently via our own fetch rather than observing the shared
      // <product-recommendations> element (assets/global.js) for DOM mutations -- that class only
      // assigns this.innerHTML when the fetched content is non-empty, so a genuine 0-result intent
      // (e.g. no complementary products configured in Search & Discovery yet) never mutates the
      // DOM at all and a MutationObserver would wait forever. Gated behind IntersectionObserver on
      // the whole section to keep the same lazy-load behaviour as the shared class.
      const lazyObserver = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        this.panels.forEach((panel) => {
          const key = panel.dataset.tabsPanel;
          const widget = panel.querySelector('product-recommendations');
          if (widget && widget.dataset.url) this.checkPanel(key, widget.dataset.url);
        });
      });
      lazyObserver.observe(root);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          if (tab.classList.contains('active')) return;
          this.activate(tab.dataset.tabsPanel);
        });
      });
    }

    checkPanel(key, url) {
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const hasContent = html.querySelector('.product-recommendations__item') !== null;
          this.state.set(key, hasContent ? 'has-content' : 'empty');
          this.refresh();
        })
        .catch(() => {
          this.state.set(key, 'empty');
          this.refresh();
        });
    }

    refresh() {
      // Whole-section hide decision is based on panel content, not tab count -- when only one
      // tab is enabled in admin there's no tab bar at all (this.tabs is empty by design), which
      // must not be confused with "every tab got hidden because it was empty."
      const allSettled = Array.from(this.state.values()).every((value) => value !== 'pending');
      const anyHasContent = Array.from(this.state.values()).some((value) => value === 'has-content');

      if (allSettled && !anyHasContent) {
        this.root.hidden = true;
        return;
      }

      if (this.tabs.length === 0) return;

      this.tabs.forEach((tab) => {
        if (this.state.get(tab.dataset.tabsPanel) === 'empty') {
          tab.hidden = true;
        }
      });

      const visibleTabs = this.tabs.filter((tab) => !tab.hidden);
      if (visibleTabs.length === 0) return;

      if (visibleTabs.length === 1) {
        this.activate(visibleTabs[0].dataset.tabsPanel);
        return;
      }

      const activeTab = this.tabs.find((tab) => tab.classList.contains('active'));
      const activeKey = activeTab ? activeTab.dataset.tabsPanel : null;
      if (activeKey && this.state.get(activeKey) === 'empty') {
        this.activate(visibleTabs[0].dataset.tabsPanel);
      }
    }

    activate(key) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tabsPanel === key;
        tab.classList.toggle('active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabsPanel === key;
        panel.classList.toggle('active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  const init = (root) => {
    if (!root || root.dataset.tabsInitialised) return;
    root.dataset.tabsInitialised = 'true';
    new RecommendationsTabs(root);
  };

  document.querySelectorAll('.product-recommendations-tabs__outer').forEach(init);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.product-recommendations-tabs__outer');
    if (root) init(root);
  });
})();
